
import { Component, Mixins, Prop, Ref, Watch } from "vue-property-decorator";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import CinsiyetPicker from "@/components/pickers/CinsiyetPicker.vue";
import EPosta from "@/components/inputs/EPosta.vue";
import VekilTipiPicker from "@/components/pickers/VekilTipiPicker.vue";
import PersonelTipiPicker from "@/components/pickers/PersonelTipiPicker.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import Tutar from "@/components/inputs/Tutar.vue";
import YabanciKimlikNumarasi from "@/components/inputs/YabanciKimlikNumarasi.vue";
import VergiNumarasi from "@/components/inputs/VergiNumarasi.vue";
import MersisNumarasi from "@/components/inputs/MersisNumarasi.vue";
import SsoUserPicker from "@/components/pickers/SsoUserPicker.vue";
import Dates from "@/components/inputs/Dates.vue";
import YargiBirimleriPicker from "@/components/pickers/YargiBirimleriPicker.vue";

@Component({
  components: {
    YargiBirimleriPicker,
    Dates,
    SsoUserPicker,
    YabanciKimlikNumarasi,
    Tutar,
    FormWrapper,
    PersonelTipiPicker,
    VekilTipiPicker,
    CinsiyetPicker,
    TcKimlikNumarasi,
    EPosta,
    VergiNumarasi,
    MersisNumarasi,
  },
})
export default class PersonelForm extends Mixins(ObjectInputMixin) {
  @Prop({}) buroTuru!: number | null;
  @Prop({}) vergiDairesi!: string | null;
  @Prop({}) vergiKimlik!: number | null;
  @Prop({}) mersisNo!: number | null;
  @Prop({ default: () => [] }) buroPersoneller!: Array<any>;
  @Prop({}) action!: string;
  @Prop() hideButton!: any;
  @Ref("formWrapper") formWrapper!: FormWrapper;

  roleData = null;
  isNonSSOUser = false;
  userStatus: 'not_found' | 'incomplete_registration' | 'registered' | null = null;

  /**
   * Pasife alınan personelin yeniden eklenmesi bekleme süresine takılıyorsa
   * backend'den dönen bilgi. Dolu olduğu sürece Kaydet butonu pasiftir.
   */
  eklemeEngeli: any = null;

  get eklemeEngeliMesaji(): string {
    if (!this.eklemeEngeli) return "";
    const kalan = Number(this.eklemeEngeli.kalan_saniye || 0);
    const dakika = Math.ceil(kalan / 60);
    return `Bu kullanıcı pasife alındığı için henüz yeniden eklenemez. Yaklaşık ${dakika} dk sonra tekrar deneyebilirsiniz.`;
  }

  /** E-posta seçildiğinde/değiştiğinde ekleme yapılabilir mi diye sorar. */
  @Watch("localValue.email")
  onEmailDegisti(email: string) {
    this.eklemeEngeli = null;

    // Düzenleme ekranında bu kural uygulanmaz.
    if (!email || this.localValue.id) return;

    this.$http
      .get("/api/v1/personel/ekleme-kontrol", { params: { email } })
      .then((res: any) => {
        const veri = res?.data?.data ?? res?.data ?? {};
        this.eklemeEngeli = veri.eklenebilir === false ? veri : null;
      })
      .catch(() => {
        // Kontrol yapılamazsa formu kilitleme; sunucu kaydederken zaten doğrular.
        this.eklemeEngeli = null;
      });
  }

  handleUserStatus(status: 'not_found' | 'incomplete_registration' | 'registered' | null) {
    this.userStatus = status;
    console.log('Kullanıcı Durumu Alındı:', this.userStatus);
    if (status === 'incomplete_registration') {
      // Tek davet mailine geçildi: kişinin SSO'da kaydı olsun olmasın AYNI
      // BuroDavetMaili gider ve ne isteneceğine davet ekranı karar verir.
      this.$toast.info("Bu kişinin kaydı henüz tamamlanmamış. Eklediğinizde kendisine bir davet e-postası gönderilir.");
    }
  }


  get alertMessage(): string {
    if (this.userStatus === 'not_found') {
      return "Eklenen kişinin kaydı bulunmamaktadır. Eklediğiniz zaman bildirim maile iletilecektir.";
    } else if (this.userStatus === 'incomplete_registration') {
      return "Bu kişinin kaydı henüz tamamlanmamış; bilgilerini tamamlamadan sisteme giriş yapamaz. Eklediğinizde kendisine e-posta gönderilir ve önceki bağlantı geçersiz olur.";
    }
    return "";
  }

  get personelTuruRules() {
    return this.localValue.role_id ? true : "Lütfen bu alanı doldurun.";
  }

  get notIdariYonetici(): boolean {
    return this.localValue.role_id === 3;
  }

  get isHideButton() {
    return this.hideButton || this.hideButton === "";
  }

  handleNonSSOUser(isNonSSOUser: boolean) {
    this.isNonSSOUser = isNonSSOUser;
    if (this.userStatus !== 'incomplete_registration') {
        this.userStatus = isNonSSOUser ? 'not_found' : 'registered';
      }
  }

  onClose() {
    this.$emit("onClose");
  }

  mounted() {
    this.localValue.vergi_no = this.vergiKimlik;
    this.localValue.vergi_dairesi = this.vergiDairesi;
    this.localValue.mersis_no = this.mersisNo;
  }

  save() {
    // Pasife alınan personelin bekleme süresi dolmadıysa kaydetmeye izin verme.
    if (this.eklemeEngeli) {
      this.$toast.error(this.eklemeEngeliMesaji);
      return;
    }

    // NOT: Kaydı tamamlanmamış ('incomplete_registration') kişi de eklenebilir.
    // Bu durumda backend daveti yeniler ve yeni bir kayıt tamamlama e-postası
    // gönderir; eski bağlantı geçersiz kılınır.
    this.formWrapper.onFly = true;

    if (this.isNonSSOUser) {
      this.localValue.sso_user_id = null;
    }

    if (!this.localValue.sso_user_id && !this.localValue.email) {
      this.$toast.error("Lütfen bir kullanıcı seçin.");
      this.formWrapper.onFly = false;
      return;
    }

    // İstediğiniz alanları tek tek payload'a ekliyorsunuz:
    const payload = {
      sso_user_id:    this.localValue.sso_user_id,
      email:          this.localValue.email,
      giris_tarihi:   this.localValue.giris_tarihi,
      cikis_tarihi:   this.localValue.cikis_tarihi,
      mersis_no:      this.localValue.mersis_no,
      vekil_tipi:      this.localValue.vekil_tipi,
      role_id:        this.localValue.role_id,
      vergi_dairesi:  this.localValue.vergi_dairesi,
      vergi_no:       this.localValue.vergi_no,
      bakanlik_sicil_no: this.localValue.bakanlik_sicil_no,
      tbb_sicil_no:   this.localValue.tbb_sicil_no,
      baro_sicil_no:   this.localValue.baro_sicil_no,
      maas:             this.localValue.maas,
      // vb. başka hangi alanları eklemek istiyorsanız buraya ekleyebilirsiniz
    };

    if (this.localValue.id) {
      this.$http.put(this.action, payload).then((response: any) => {
        this.cikisTarihiBildirimi(response);
        this.$emit("onSuccess");
      }).finally(() => (this.formWrapper.onFly = false));
    } else {
      // Büro detayda zaten çekilen personeller üzerinden kontrol et
      const buroPersoneller = this.buroPersoneller || [];
      const zatenEkli = buroPersoneller.some((p: any) =>
        (this.localValue.sso_user_id != null && p.sso_user_id == this.localValue.sso_user_id) ||
        (this.localValue.email && String(p.email || "").toLowerCase() === String(this.localValue.email || "").toLowerCase())
      );
      if (zatenEkli) {
        this.$toast.error("Kullanıcı zaten ekli.");
        this.formWrapper.onFly = false;
      } else {
        this.$http
            .post(this.action, payload)
            .then(() => {
              this.$toast.info(
                  "İşlemin tamamlanması için eklenen kullanıcının eposta adresine gönderilen doğrulama linkine tıklaması gerekmektedir."
              );
              this.$emit("onSuccess");
            })
            .finally(() => (this.formWrapper.onFly = false));
      }
    }
  }

  /**
   * "İşten Ayrılma Tarihi" değişikliğinin sonucunu kullanıcıya söyler.
   *
   * Bu geri bildirim olmadan iki durum sessiz kalıyordu:
   *  - tarih girildi -> kişi pasife düştü ve listeden kayboldu (pasifler ana
   *    listede gösterilmiyor), yönetici kaydın silindiğini sanabilir,
   *  - tarih silindi -> kişiye yeniden davet maili GİTTİ ama ekranda hiçbir iz
   *    yok; yönetici kişinin anında aktifleştiğini sanır, oysa daveti kabul
   *    edene kadar giriş yapamaz.
   *
   * Karar backend'de verilir (UserController@update); burada yalnız gösterilir.
   */
  cikisTarihiBildirimi(response: any) {
    const karar = response && response.cikis_tarihi_karari;
    if (!karar) return;

    if (karar.islem === "pasife_alma" && karar.sonuc === "pasife_alindi") {
      this.$toast.info(
        "İşten ayrılma tarihi geldiği için personel pasife alındı. " +
        "Pasif Kullanıcılar ekranından görüntüleyebilirsiniz."
      );
      return;
    }

    if (karar.islem === "yeniden_davet") {
      if (karar.kod === "buro_secimi_gerekli") {
        // Bürosu silinmiş kişi hedef büro seçilmeden geri getirilemez.
        this.$toast.error(
          "Tarih temizlendi ancak personelin bürosu silinmiş. " +
          "Aktifleştirmek için Pasif Kullanıcılar ekranından büro seçin."
        );
      } else if (karar.mail_gonderildi) {
        this.$toast.info(
          "İşten ayrılma tarihi temizlendi; personele yeniden davet e-postası gönderildi. " +
          "Daveti kabul ettiğinde erişimi açılacak."
        );
      } else {
        this.$toast.error(
          "İşten ayrılma tarihi temizlendi ancak personel aktifleştirilemedi. " +
          "Pasif Kullanıcılar ekranından tekrar deneyin."
        );
      }
    }
  }

  onPersonelTipiChange() {
    delete this.localValue.vekil_tipi;
    this.input();
  }
}
